import * as tslib_1 from "tslib";
import { RoutingActionTypes } from './types';
var initialState = {
    fos_router: null,
    routeSlugMap: null,
    routeSlugGroupIdMaps: {}
};
var reducer = function (state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case RoutingActionTypes.RECEIVE_FOS_ROUTES: {
            return tslib_1.__assign({}, state, { fos_router: action.fos_router });
        }
        case RoutingActionTypes.CREATE_ROUTE_SLUGS: {
            return tslib_1.__assign({}, state, { routeSlugMap: action.routeSlugMap, routeSlugGroupIdMaps: action.routeSlugGroupIdMaps });
        }
        default: {
            return state;
        }
    }
};
export { reducer as routesReducer };
